import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit,
  ViewEncapsulation,
} from '@angular/core';

import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-terms-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    FormsModule,
    MatIconModule,
  ],
  templateUrl: './terms-dialog.component.html',
  styleUrls: ['./terms-dialog.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class TermsDialogComponent implements AfterViewInit {
  @ViewChild('termsContainer') termsContainer!: ElementRef;
  @ViewChild('termsContent') termsContent!: ElementRef;
  hasAcceptedTerms = false;
  hasScrolledToBottom = false;

  constructor(
    private dialogRef: MatDialogRef<TermsDialogComponent>,
    private elementRef: ElementRef,
    private http: HttpClient
  ) {}

  ngAfterViewInit() {
    // Load terms from local file
    this.http
      .get('assets/documents/TerminiDiServizio.html', { responseType: 'text' })
      .subscribe((content) => {
        // Wrap the content in a div with a class to target for styling
        const wrappedContent = `<div class="terms-content-wrapper">${content}</div>`;
        this.termsContainer.nativeElement.innerHTML = wrappedContent;

        // Ensure content starts from top and setup scroll monitoring
        setTimeout(() => {
          const content = this.termsContent.nativeElement;
          content.scrollTop = 0;

          content.addEventListener('scroll', () => {
            const scrolledToBottom =
              content.scrollHeight - content.scrollTop - content.clientHeight <=
              1;

            if (scrolledToBottom) {
              this.hasScrolledToBottom = true;
            }
          });
        }, 100); // Reduced timeout since we don't need to wait for external content
      });
  }

  acceptTerms() {
    if (this.hasAcceptedTerms && this.hasScrolledToBottom) {
      this.dialogRef.close(true);
    }
  }

  onCheckboxChange() {
    if (!this.hasAcceptedTerms) {
      this.hasScrolledToBottom = false;
    }
  }
}
